import React, { SVGProps } from 'react'
export const FifthDefaultLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M5.712 6.319C2.788 9.033.84 13.012 1.01 19c.133 4.687 2.128 8.065 5.025 10.485C8.948 31.92 12.003 33.5 16 34v1c-3.997-.5-7.523-2.172-10.605-4.747C2.297 27.665.153 24.026.01 19.028c-.178-6.25 1.868-10.515 5.022-13.442C8.166 2.678 11.503 2 16 1v1C11.503 3 8.658 3.586 5.712 6.319Z"
      clipRule="evenodd"
    />
  </svg>
)
